
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { MonthYearSelect } from '@/components/teacher/MonthYearSelect';
import { TeacherMonthlySummary } from '@/components/teacher/TeacherMonthlySummary';
import { TeacherReportDetails } from '@/components/teacher/TeacherReportDetails';
import { useTeacherSalary } from '@/hooks/useTeacherSalary';

const TeacherSalaryPage: React.FC = () => {
  const [selectedMonth, setSelectedMonth] = React.useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = React.useState(new Date().getFullYear());

  const { monthlyReport, isLoading, reportDetails, refetch } = useTeacherSalary(selectedMonth, selectedYear);

  return (
    <div className="min-h-screen bg-gray-50 w-full">
      <header className="bg-form-blue text-white py-6 shadow-md relative w-full">
        <div className="w-full px-4 flex items-center">
          <Link 
            to="/" 
            className="absolute left-4 top-1/2 -translate-y-1/2 p-2 hover:bg-blue-600 rounded-full transition-colors"
          >
            <ChevronLeft className="w-6 h-6" />
          </Link>
          <div className="flex-grow text-center">
            <h1 className="text-2xl md:text-3xl font-bold">เงินเดือนครู</h1>
            <p className="mt-2 text-blue-100">รายละเอียดเงินเดือนและค่าสอนรายเดือน</p>
          </div>
        </div>
      </header>

      <main className="w-full px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 w-full">
          <MonthYearSelect
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            onMonthChange={setSelectedMonth}
            onYearChange={setSelectedYear}
          />

          {isLoading ? (
            <div>กำลังโหลดข้อมูล...</div>
          ) : monthlyReport ? (
            <>
              <TeacherMonthlySummary 
                monthlyReport={monthlyReport} 
                onConfirm={refetch}
              />
              <div className="mt-6 w-full">
                <TeacherReportDetails reportDetails={reportDetails} />
              </div>
            </>
          ) : (
            <div className="text-center text-muted-foreground">
              ไม่มีข้อมูลเงินเดือนสำหรับเดือนนี้
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default TeacherSalaryPage;
